import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';

/**
 * Capacity Dialog for editing employee weekly hours
 */
const CapacityDialog = ({
  open,
  onOpenChange,
  form,
  setForm,
  selectedEmployee,
  isSubmitting,
  onSubmit
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>
            Kapazität bearbeiten
          </DialogTitle>
          <DialogDescription>
            Ändern Sie die wöchentliche Arbeitszeit für {selectedEmployee?.user_name || 'Mitarbeiter'}.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="weekly_hours">Wochenstunden</Label>
            <Input
              id="weekly_hours"
              type="number"
              min="0"
              max="80"
              step="0.5"
              value={form.weekly_hours}
              onChange={(e) => setForm(prev => ({ ...prev, weekly_hours: parseFloat(e.target.value) || 0 }))}
            />
            <p className="text-xs text-gray-500">
              Standard: 40 Stunden/Woche
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="notes">Notizen (optional)</Label>
            <Textarea
              id="notes"
              value={form.notes}
              onChange={(e) => setForm(prev => ({ ...prev, notes: e.target.value }))}
              placeholder="z.B. Teilzeit, reduziertes Pensum..."
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Abbrechen
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Speichern
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CapacityDialog;
